__turbopack_context__.v({
  "footerBar": "Footer-module__3f67YW__footerBar",
  "footerTopLeft": "Footer-module__3f67YW__footerTopLeft",
  "footerTopRight": "Footer-module__3f67YW__footerTopRight",
  "linksList": "Footer-module__3f67YW__linksList",
  "socialIcons": "Footer-module__3f67YW__socialIcons",
});
